var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种管理-新增")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "保单名称",
      "prop": "insurance_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入保单名称"
    },
    model: {
      value: (_vm.ruleForm.insurance_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "insurance_name", $$v)
      },
      expression: "ruleForm.insurance_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "投保账户",
      "prop": "insure_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入投保账户"
    },
    model: {
      value: (_vm.ruleForm.insure_account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "insure_account", $$v)
      },
      expression: "ruleForm.insure_account"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "投保内容",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "74%"
    },
    attrs: {
      "placeholder": "请选择投保内容",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.dictionaries_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dictionaries_id", $$v)
      },
      expression: "ruleForm.dictionaries_id"
    }
  }, _vm._l((_vm.cxList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生效时间",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.start_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "start_date", $$v)
      },
      expression: "ruleForm.start_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "88%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.end_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "end_date", $$v)
      },
      expression: "ruleForm.end_date"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "承保公司",
      "prop": "company_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "74%"
    },
    attrs: {
      "placeholder": "请选择承保公司",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.company_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "company_id", $$v)
      },
      expression: "ruleForm.company_id"
    }
  }, _vm._l((_vm.cbgsList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.company_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "单价",
      "prop": "unit_price"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单价"
    },
    model: {
      value: (_vm.ruleForm.unit_price),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "unit_price", $$v)
      },
      expression: "ruleForm.unit_price"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单号",
      "prop": "policy_no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入保单号"
    },
    model: {
      value: (_vm.ruleForm.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "policy_no", $$v)
      },
      expression: "ruleForm.policy_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保费",
      "prop": "premium"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入保费"
    },
    model: {
      value: (_vm.ruleForm.premium),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "premium", $$v)
      },
      expression: "ruleForm.premium"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保额",
      "prop": "insured_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入保额"
    },
    model: {
      value: (_vm.ruleForm.insured_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "insured_amount", $$v)
      },
      expression: "ruleForm.insured_amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "免赔额、比例",
      "prop": "proportion"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入免赔额、比例"
    },
    model: {
      value: (_vm.ruleForm.proportion),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "proportion", $$v)
      },
      expression: "ruleForm.proportion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系人",
      "prop": "company_contacts"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承保公司联系人"
    },
    model: {
      value: (_vm.ruleForm.company_contacts),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "company_contacts", $$v)
      },
      expression: "ruleForm.company_contacts"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系电话",
      "prop": "company_telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入承保公司联系电话"
    },
    model: {
      value: (_vm.ruleForm.company_telephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "company_telephone", $$v)
      },
      expression: "ruleForm.company_telephone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "89%"
    },
    attrs: {
      "placeholder": "请输入备注内容"
    },
    model: {
      value: (_vm.ruleForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remarks", $$v)
      },
      expression: "ruleForm.remarks"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "备用1",
      "prop": "spare1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.spare1),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spare1", $$v)
      },
      expression: "ruleForm.spare1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "备用2",
      "prop": "spare2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.spare2),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "spare2", $$v)
      },
      expression: "ruleForm.spare2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单扫描件",
      "prop": "insurance_url"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + 'file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.ruleForm.insurance_url,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.insurance_url,
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "其他附件",
      "prop": "enclosure_url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadFujian,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.ruleForm.enclosure_url,
      "v-model": _vm.ruleForm.enclosure_url
    }
  }, [_c('el-button', {
    staticStyle: {
      "font-size": "10px",
      "width": "100px"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("上传附件")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "550px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ac23ac","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzGl/Qtxzgl_add.vue
// module id = null
// module chunks = 